import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { ModalType } from './Modal';
import { fontDisplay, fontText, isMobileApp, StylesIndexInjections } from 'common-react';
interface ModalStyleProps {
  type?: ModalType;
  titleType?: 'center' | 'left';
  customZIndex?: number;
}

const getZIndex = ({ customZIndex, type }: ModalStyleProps) => customZIndex || (type === ModalType.menuModal ? 999 : 1001);
export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    width: 'auto',
    height: '100%',
    overflowY: 'auto',
    maxWidth: '100%',
    zIndex: getZIndex,

    [theme.breakpoints.down('sm')]: {
      overflowY: 'scroll',
      padding: ({ type }: ModalStyleProps) => type === ModalType.menuModal ? 0 : '',
      paddingTop: isMobileApp() ? theme.space.mobileTopPadding() : undefined,
    },

    [theme.breakpoints.up('md')]: {
      padding: ({ type }) => type === ModalType.modalCard ? 0 : '24px 28px',
    },
  },

  closeButton: {
    position: 'absolute',
    padding: 14,
    top: 12,
    right: 8,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    color: theme.color.greys[80],
    '& svg': {
      verticalAlign: 'top',
      width: 20,
      height: 20,
    },

    '& path': {
      stroke: theme.color.greys[80],
    },
  },
  header: {
    position: 'relative',
    '@media (min-width: 960px)': {
      margin: `-24px -28px 20px`,
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: ({ titleType }: ModalStyleProps) => titleType === 'center' ? 'center' : 'flex-start',
  },
  headerWithButtons: {
    position: 'relative',
    borderBottom: `1px solid ${theme.color.greys[20]}`,
    marginBottom: 20,
    padding: 16,
  },
  titleWithButtons: {
    font: fontDisplay('normal', theme.fontSize.subHeadline2, 36),
    color: theme.color.greys[80],
  },
  menuModal: {
    position: 'relative',
    marginBottom: 0,
    padding: 16,
  },
  title: {
    color: theme.color.greys[80],
  },
  'title--center': {
    margin: '14px 0 18px',
    font: fontText('normal', theme.fontSize.base, 20),
  },
  'title--left': {
    margin: '16px 16px',
    font: fontText('normal', theme.fontSize.xl, 24),
    '@media (min-width: 960px)': {
      margin: '28px 28px',
      font: fontText('normal', theme.fontSize.xxl, 32)
    },
  },
  modalWithLayout: {
    '@media (max-width: 959px)': {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  layout: {
    maxWidth: 'initial',
  },
}), { name: 'Modal', index: StylesIndexInjections.UI_MOLECULES });
